import React from "react";
import { Button as MUIButton } from "@mui/material";
import { useApp } from "context";

type Props = {
  sx?: any;
  tabIndex?: number;
  size?: "small" | "medium" | "large";
  href?: string;
  submit?: boolean;
  children: string | React.ReactNode;
  disabled?: boolean;
  variant?: "outlined" | "contained";
  onClick?: (
    event: React.MouseEventHandler<HTMLButtonElement> | undefined
  ) => void;
};

export const Button = (props: Props) => {
  const { theme } = useApp();

  const isOutlined = props.variant === "outlined";

  return (
    <MUIButton
      size={props.size}
      href={props.href}
      disabled={props.disabled}
      tabIndex={props.tabIndex}
      variant={props.variant ?? "contained"}
      sx={{
        borderRadius: theme.border.radius,
        borderColor: isOutlined ? theme.color.primary.color : null,
        backgroundColor: isOutlined
          ? "transparent"
          : props.sx?.backgroundColor ?? theme.color.primary.color,
        color: isOutlined
          ? theme.color.primary.color
          : props.sx?.color ?? theme.color.primary.text,
        "&.Mui-disabled": isOutlined
          ? { color: theme.disabled.color, borderColor: theme.disabled.color }
          : theme.disabled,
        "&:hover": {
          opacity: 0.7,
          color: isOutlined
            ? theme.color.primary.color
            : props.sx?.color ?? theme.color.primary.text,
          backgroundColor: isOutlined
            ? "transparent"
            : props.sx?.backgroundColor ?? theme.color.primary.color,
        },
        ...props.sx,
      }}
      onClick={(event: any) => props.onClick && props.onClick(event)}
      type={props.submit ? "submit" : "button"}
    >
      {props.children}
    </MUIButton>
  );
};
